import React, {useEffect, useState} from 'react';
import {Col, Row} from 'reactstrap';
import {shallowEqual, useSelector} from 'react-redux';
import PropTypes from 'prop-types';
import moment from 'moment';
import CustomSearch from "@pages/components/CustomSearch";
import CalendarFilter from "@pages/components/CalendarFilter";
import {SelectWithoutInput} from "@pages/components/InputSelect";

const Filter = ({ fetchData, showStatusFilter = true, showTypeFilter = true,
                  vehicleMakes,
                  models,
                  makeValue,
                  setMakeFilter,
                  setModelFilter,
                  modelValue,
}) => {
  const leadState = useSelector((state) => state.leadState, shallowEqual);
  const [filter, setFilter] = useState({});
  const [authUserTeam, setAuthUserTeam] = useState('');
  const [dealers, setDealers] = useState([]);
  const [leadsStatuses, setLeadsStatuses] = useState('');
  const [leadsTypes, setLeadsTypes] = useState('');

  useEffect(() => {
    setLeadsStatuses(leadState.leadsStatuses);
    setLeadsTypes(leadState.leadsTypes);
    setAuthUserTeam(leadState.authUserTeam);
    setFilter({
      ...leadState.filter,
      from: moment(leadState.filter.from).format('YYYY-MM-DD'),
      to: moment(leadState.filter.to).format('YYYY-MM-DD'),
    });

    if (!leadState.authUserTeam) {
      setDealers(leadState.dealers);
    }
  }, [leadState]);


  const findData = (key,val) => {
    let temp = {...filter, [key]: val,}
    fetchData(1, temp);
    setFilter(temp)
  }
  const selectDate =(date)=>{
    let temp = {...filter,...date}
    fetchData(1, temp);
    setFilter(temp)
  }
  return (
      <div className="d-flex flex-wrap g-10 p-2">
        {/* Search */}
        <CustomSearch
            border={'1px solid #ccc'}
            borderRadius={'8px'}
            onChange={(e) => findData("search", e.target.value)}
            placeholder="Name"
        />

        {/* Date filter */}
        <CalendarFilter
            filterByDate={(data) => selectDate(data)}
        />

        {/* Dealer (only if not in authUserTeam) */}
        {!authUserTeam && (
            <SelectWithoutInput
                label={
                  filter?.dealerId && dealers[filter?.dealerId]
                      ? dealers[filter?.dealerId]
                      : `Dealer`
                }
                onSelect={(e) =>
                    findData(
                        "dealerId",
                        Object.keys(dealers).find((key) => dealers[key] === e)
                    )
                }
                options={Object.values(dealers)}
                defaultOption={true}
                imageLink={"group-p.png"}
            />
        )}

        {showStatusFilter && (
            <SelectWithoutInput
                fullWidth={true}
                label={
                  filter?.statusFilter
                      ? leadsStatuses[filter?.statusFilter]
                      : `Status`
                }
                onSelect={(e) =>
                    findData(
                        "statusFilter",
                        Object.keys(leadsStatuses).find((key) => leadsStatuses[key] === e)
                    )
                }
                options={Object.values(leadsStatuses)}
                defaultOption={true}
                imageLink={"loyalty.png"}
            />
        )}

        {/* Types (conditionally shown) */}
        {showTypeFilter && (
            <SelectWithoutInput
                fullWidth={true}
                label={
                  filter?.typeFilter
                      ? leadsTypes[filter?.typeFilter]
                      : `Types`
                }
                onSelect={(e) =>
                    findData(
                        "typeFilter",
                        Object.keys(leadsTypes).find((key) => leadsTypes[key] === e)
                    )
                }
                options={Object.values(leadsTypes)}
                defaultOption={true}
                imageLink={"loyalty.png"}
            />
        )}
       <Col lg={3} sm={12}>
           <SelectWithoutInput
               showClear={true}
               label={makeValue ? makeValue : `Make`}
               onSelect={setMakeFilter}
               options={vehicleMakes}
               wholeData
               defaultOption={true}
               labelKey={`name`}
               valueKey={`id`}
               imageLink={'directions_car_grey.png'}
           />
       </Col>
      <Col lg={3} sm={12}>
          <SelectWithoutInput
              showClear={true}
              wholeData
              label={modelValue ? modelValue : `Model`}
              onSelect={(e) => {
                  setModelFilter(e)
              }}
              options={models}
              defaultOption={true}
              labelKey={`name`}
              valueKey={`id`}
              imageLink={'loyalty.png'}
          />
      </Col>
      </div>
  );
};

export default React.memo(Filter);

Filter.propTypes = {
  fetchData: PropTypes.func,
  resetLeads: PropTypes.func,
};
